(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jp-product-youtube"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-jp-youtube] .jp-product-youtube__button');
    if (!button) return;

    var root = button.closest('[data-jp-youtube]');
    var videoId = root && root.getAttribute('data-video-id');
    if (!videoId || root.getAttribute('data-jp-youtube-loaded') === 'true') return;

    root.setAttribute('data-jp-youtube-loaded', 'true');
    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(videoId) + '?autoplay=1&rel=0';
    iframe.title = 'YouTube video';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    iframe.loading = 'lazy';
    root.replaceChildren(iframe);
  });
  } catch(e) { console.error(e); }
})();

})();
